export default function scroll() {
  window.addEventListener('scroll', function() {
    let scroll = this.scrollY;
    let width = window.innerWidth

    if(width <= 1000 && scroll <=70) {
      document.querySelectorAll('.band_header_small').forEach(e => {
        e.style.position = '-webkit-sticky';
      });
      document.querySelectorAll('.band_header_small').forEach(e => {
        e.style.position = 'sticky';
      });
      document.querySelectorAll('.scroll').forEach(e => {
        e.style.marginTop = '30px';
      });
      document.querySelectorAll('.big-link').forEach(e => {
        e.style.fontSize = '2rem';
      });

    } else if (width <= 1000) {
      document.querySelectorAll('.band_header_small').forEach(e => {
        e.style.position = 'fixed';
        e.style.top = '8vh';
        e.style.zIndex = '999';
      });
      document.querySelectorAll('.scroll').forEach(e => {
        e.style.marginTop = 'calc(30px + 8vh)';
      });
      document.querySelectorAll('.big-link').forEach(e => {
        e.style.fontSize = '1.4rem';
        e.style.transition = '.4s';
      });
    }
    if (scroll <= 70) {
      document.getElementById('nav_bar').style.height = '8vh';
      document.getElementById('nav_bar').style.backgroundColor = 'transparent';
    } else {
      document.getElementById('nav_bar').style.height = '8vh';
      document.getElementById('nav_bar').style.backgroundColor = '#2d2d2f';
    }
  });
}



// WEBPACK FOOTER //
// ./src/Components/Tools/scroll.js